var UX;
(function (UX) {
    var Controller = (function () {
        function Controller() {
            $(document).on('click', '.helper-icon', function () {
                var self = $(this);
                self.toggleClass('active');

                var box = $('#' + self.data('box-id'));
                box.toggleClass('active');
                if (box.is('.active')) {
                    var height = 0;
                    box.children().each(function () {
                        height += $(this).outerHeight(true);
                    });
                    box.css('height', height + "px");
                } else {
                    box.css('height', 0);
                }
            }).on('click', '.helper-box-close', function () {
                var self = $(this);

                var box = $('#' + self.data('box-id'));
                box.toggleClass('active');
                if (box.is('.active')) {
                    var height = 0;
                    box.children().each(function () {
                        height += $(this).outerHeight(true);
                    });
                    box.css('height', height + "px");
                } else {
                    box.css('height', 0);
                }

                $('.helper-icon[data-box-id="' + self.data('box-id') + '"]').toggleClass('active');
            });
        }

        return Controller;
    })();
    UX.Controller = Controller;
})(UX || (UX = {}));

var ux = new UX.Controller();